"use strict";

module.exports = require('./Switch');


//////////////////
// WEBPACK FOOTER
// ./~/antd/~/rc-switch/lib/index.js
// module id = 1444
// module chunks = 0